
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/races-runners/runners/[level3]",
      function () {
        return require("private-next-pages/races-runners/runners/[level3]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/races-runners/runners/[level3]"])
      });
    }
  